<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith unselectable" (keydown.enter)="$event.preventDefault()">
  <div class="unselectable headerTitle headline">Schadenfall</div>
  <form id="damageCaseForm" class="row">
    <!-- Search -->
    <div class="col-2">
      <mat-form-field class="formField">
        <input #caseId type="text" placeholder="Schadenfallnummer" matInput [value]="damageCase.Id" readonly>
      </mat-form-field>
    </div>
    <div class="col-10">
      <mat-form-field class="formField">
        <input #searchElement type="text" placeholder="Schaden suchen..." matInput [formControl]="caseIdControl" [matAutocomplete]="autoDamageCase">
        <mat-autocomplete #autoDamageCase="matAutocomplete">
          <mat-option *ngFor="let id of filteredCaseIds | async" (onSelectionChange)="onCaseIdSelectionChange(id, $event)" [value]="id">{{id}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-12">
      <!-- Details -->
      <mat-card class="damageCard">
        <mat-card-title class="row unselectable subTitle subhead damageCaseCardTitle">Details</mat-card-title>
        <mat-card-content>
          <div class="row">
            <!-- Statuses if CostEstimate is below CHF 2000 -->
            <div class="col-12" *ngIf="damageCase.CostEstimate < 2000">
              <div class="stateContainer">
                <div class="state" [class.active]="states[0].value === damageCase.InternalState" (click)="damageCase.InternalState = states[0].value">
                  {{ states[0].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[1].value === damageCase.InternalState" (click)="damageCase.InternalState = states[1].value">
                  {{ states[1].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[2].value === damageCase.InternalState" (click)="damageCase.InternalState = states[2].value">
                  {{ states[2].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[3].value === damageCase.InternalState" (click)="damageCase.InternalState = states[3].value">
                  {{ states[3].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[7].value === damageCase.InternalState" (click)="damageCase.InternalState = states[7].value">
                  {{ states[7].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[9].value === damageCase.InternalState" (click)="damageCase.InternalState = states[9].value">
                  {{ states[9].label }}
                </div>
              </div>
            </div>
            <!-- Statuses if CostEstimate is above CHF 2000 but below 5000 -->
            <div class="col-12" *ngIf="damageCase.CostEstimate >= 2000 && damageCase.CostEstimate < 5000">
              <div class="stateContainer">
                <div class="state" [class.active]="states[0].value === damageCase.InternalState" (click)="damageCase.InternalState = states[0].value">
                  {{ states[0].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[1].value === damageCase.InternalState" (click)="damageCase.InternalState = states[1].value">
                  {{ states[1].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[2].value === damageCase.InternalState" (click)="damageCase.InternalState = states[2].value">
                  {{ states[2].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[3].value === damageCase.InternalState" (click)="damageCase.InternalState = states[3].value">
                  {{ states[3].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[4].value === damageCase.InternalState" (click)="damageCase.InternalState = states[4].value">
                  {{ states[4].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[7].value === damageCase.InternalState" (click)="damageCase.InternalState = states[7].value">
                  {{ states[7].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[8].value === damageCase.InternalState" (click)="damageCase.InternalState = states[8].value">
                  {{ states[8].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[9].value === damageCase.InternalState" (click)="damageCase.InternalState = states[9].value">
                  {{ states[9].label }}
                </div>
              </div>
            </div>
            <!-- Statuses if CostEstimate is above CHF 5000 -->
            <div class="col-12" *ngIf="damageCase.CostEstimate >= 5000">
              <div class="stateContainer">
                <div class="state" [class.active]="states[0].value === damageCase.InternalState" (click)="damageCase.InternalState = states[0].value">
                  {{ states[0].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[1].value === damageCase.InternalState" (click)="damageCase.InternalState = states[1].value">
                  {{ states[1].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[2].value === damageCase.InternalState" (click)="damageCase.InternalState = states[2].value">
                  {{ states[2].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[3].value === damageCase.InternalState" (click)="damageCase.InternalState = states[3].value">
                  {{ states[3].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[4].value === damageCase.InternalState" (click)="damageCase.InternalState = states[4].value">
                  {{ states[4].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[5].value === damageCase.InternalState" (click)="damageCase.InternalState = states[5].value">
                  {{ states[5].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[6].value === damageCase.InternalState" (click)="damageCase.InternalState = states[6].value">
                  {{ states[6].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[7].value === damageCase.InternalState" (click)="damageCase.InternalState = states[7].value">
                  {{ states[7].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[8].value === damageCase.InternalState" (click)="damageCase.InternalState = states[8].value">
                  {{ states[8].label }}
                </div>
                <div class="line"></div>
                <div class="state" [class.active]="states[9].value === damageCase.InternalState" (click)="damageCase.InternalState = states[9].value">
                  {{ states[9].label }}
                </div>
              </div>
            </div>
            <!-- Original Data-->
            <!--<div class="col-3" *ngIf="damageCase.Id != 0"></div>
            <div class="col-6 originalDataContainer" *ngIf="damageCase.Id != 0">
              <mat-expansion-panel hideToggle class="originalDataPanel">
                <mat-expansion-panel-header>
                  <mat-panel-title> Originale Daten ein/-ausblenden</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-form-field class="formField" style="margin-top: 5px;">
                  <mat-label>Absender</mat-label>
                  <input matInput name="license" [value]="damageCase.OriginalSender" readonly>
                </mat-form-field>
                <mat-form-field class="formField">
                  <mat-label>Empfänger</mat-label>
                  <input matInput name="license" [value]="damageCase.OriginalRecipient" readonly>
                </mat-form-field>
                <mat-form-field class="formField">
                  <mat-label>Fahrzeug</mat-label>
                  <input matInput name="license" [value]="damageCase.OriginalModel" readonly>
                </mat-form-field>
              </mat-expansion-panel>
            </div>
            <div class="col-3" *ngIf="damageCase.Id != 0"></div>-->
            <!-- Input Fields -->
            <div class="col-3"></div>
            <div class="col-2">
              <mat-form-field class="formField">
                <input #damageDateInput name="damageDate" matInput [matDatepicker]="damageDatePicker" placeholder="Schadendatum" [(ngModel)]="tempDamageDate" [max]="maxDate" (click)="openDamageDatePicker(damageDatePicker)" required>
                <mat-datepicker-toggle matSuffix [for]="damageDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #damageDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-select placeholder="Zeit" name="damageTime" required [(ngModel)]="damageCase.DamageTime">
                  <mat-option *ngFor="let time of times" [value]="time">{{time}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="formField">
                <input type="text" placeholder="Versicherungsart" matInput [formControl]="insuranceControl" [matAutocomplete]="autoInsurance">
                <mat-autocomplete #autoInsurance="matAutocomplete" [displayWith]="displayWithText('insurance')">
                  <mat-option *ngFor="let item of filteredInsurances | async" (onSelectionChange)="onInsuranceSelectionChange(item)" [value]="item">{{item.InsuranceName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="formField">
                <input type="text" placeholder="Auftragstyp" matInput [formControl]="jobTypeControl" [matAutocomplete]="autoJobType">
                <mat-autocomplete #autoJobType="matAutocomplete" [displayWith]="displayWithText('jobType')">
                  <mat-option *ngFor="let item of filteredJobTypes | async" [value]="item">{{item.JobTypeName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="formField">
                <input type="text" placeholder="Verursacher" matInput [formControl]="employeeControl" [matAutocomplete]="autoCausedBy">
                <mat-autocomplete #autoCausedBy="matAutocomplete" [displayWith]="displayWithText('causedBy')">
                  <mat-option *ngFor="let item of filteredEmployees | async" [value]="item">{{item.LastName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="formField">
                <input type="text" placeholder="Absender" matInput [formControl]="senderControl" [matAutocomplete]="autoSender">
                <mat-autocomplete #autoSender="matAutocomplete" [displayWith]="displayWithText('receiver')">
                  <mat-option *ngFor="let item of filteredSenders | async" [value]="item">{{item.ReceiverName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="formField">
                <input type="text" placeholder="Rep. Werkstatt" matInput [formControl]="workshopControl" [matAutocomplete]="autoWorkshop">
                <mat-autocomplete #autoWorkshop="matAutocomplete" [displayWith]="displayWithText('receiver')">
                  <mat-option *ngFor="let item of filteredWorkshops | async" [value]="item">{{item.ReceiverName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="formField">
                <input type="text" placeholder="Empfänger" matInput [formControl]="receiverControl" [matAutocomplete]="autoReceiver">
                <mat-autocomplete #autoReceiver="matAutocomplete" [displayWith]="displayWithText('receiver')">
                  <mat-option *ngFor="let item of filteredReceivers | async" [value]="item">{{item.ReceiverName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-2">
              <mat-form-field class="formField">
                <input type="text" placeholder="Marke" matInput [formControl]="brandControl" [matAutocomplete]="autoBrand">
                <mat-autocomplete #autoBrand="matAutocomplete" [displayWith]="displayWithText('carBrand')">
                  <mat-option *ngFor="let item of filteredBrands | async" [value]="item">{{item.CarBrandName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="formField">
                <input type="text" placeholder="Modell" matInput [formControl]="carTypeControl" [matAutocomplete]="autoType">
                <mat-autocomplete #autoType="matAutocomplete" [displayWith]="displayWithText('carType')">
                  <mat-option *ngFor="let item of filteredCarTypes | async" [value]="item">{{item.CarTypeName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Identifikation</mat-label>
                <input matInput name="identification" [(ngModel)]="damageCase.Identification">
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Kontrollschild</mat-label>
                <input matInput name="license" [(ngModel)]="damageCase.License">
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Chassis-Nummer</mat-label>
                <input matInput name="chassisNo" [(ngModel)]="damageCase.ChassisNo">
              </mat-form-field>
              <mat-form-field class="formField">
                <input type="text" placeholder="Importeur" matInput [formControl]="importerControl" [matAutocomplete]="autoImporter">
                <mat-autocomplete #autoImporter="matAutocomplete" [displayWith]="displayWithText('importer')">
                  <mat-option *ngFor="let item of filteredImporters | async" [value]="item">{{item.ImporterName}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Police-Nr.</mat-label>
                <input matInput name="policyNo" [(ngModel)]="damageCase.PolicyNo" readonly>
              </mat-form-field>
              <div class="formFieldCheckbox">
                <mat-checkbox color="primary" name="guilty" [(ngModel)]="damageCase.Guilty">Schuldig</mat-checkbox>
              </div>
            </div>
            <div class="col-2">
              <mat-form-field class="formField">
                <input name="caseEndDate" matInput [matDatepicker]="caseEndPicker" placeholder="Dossierabschluss" [(ngModel)]="tempCaseEndDate" [max]="maxDate" (focus)="openCaseEndDatePicker(caseEndPicker)" (click)="openCaseEndDatePicker(caseEndPicker)" #caseEndFocus>
                <mat-datepicker-toggle matSuffix [for]="caseEndPicker"></mat-datepicker-toggle>
                <mat-datepicker #caseEndPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Kontierung</mat-label>
                <input matInput name="accountAssignment" [(ngModel)]="damageCase.AccountAssignment">
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Kostenvoranschlag</mat-label>
                <input matInput name="costEstimate" [(ngModel)]="damageCase.CostEstimate" type="number" class="rightAlign">
                <span matSuffix>&nbsp;CHF</span>
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Schadenbetrag</mat-label>
                <input matInput name="damageAmount" [(ngModel)]="damageCase.DamageAmount" type="number" class="rightAlign" (ngModelChange)="calculateOwnCosts()">
                <span matSuffix>&nbsp;CHF</span>
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Versicherte Leistung</mat-label>
                <input matInput name="insuranceAmount" [(ngModel)]="damageCase.InsuranceAmount" type="number" class="rightAlign" (ngModelChange)="calculateOwnCosts()">
                <span matSuffix>&nbsp;CHF</span>
              </mat-form-field>
              <mat-form-field class="formField">
                <input name="reimbursement" matInput [matDatepicker]="reimbursementPicker" placeholder="Rückvergütung" [(ngModel)]="tempReimbursementDate" (focus)="openReimbursementDatePicker(reimbursementPicker)" (click)="openReimbursementDatePicker(reimbursementPicker)" #reimbursementFocus>
                <mat-datepicker-toggle matSuffix [for]="reimbursementPicker"></mat-datepicker-toggle>
                <mat-datepicker #reimbursementPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="formField">
                <mat-label>Eigenkosten</mat-label>
                <input matInput name="ownCosts" [(ngModel)]="damageCase.OwnCosts" type="number" class="rightAlign" readonly>
                <span matSuffix>&nbsp;CHF</span>
              </mat-form-field>
              <div class="formField damageReportIconsContent" *ngIf="damageCase.DamageAmount">
                Rechnung:
                <i [ngClass]="{ 'green': damageCase.DamageAmount < damageCase.CostEstimate * 0.95 }" class="material-icons damageReportIcons">arrow_circle_down</i>
                <i [ngClass]="{ 'blue': damageCase.DamageAmount >= damageCase.CostEstimate * 0.95 && damageCase.DamageAmount <= damageCase.CostEstimate * 1.05 }" class="material-icons damageReportIcons">check_circle_outline</i>
                <i [ngClass]="{ 'red': damageCase.DamageAmount > damageCase.CostEstimate * 1.05 }" class="material-icons damageReportIcons">arrow_circle_up</i>
              </div>
            </div>
            <div class="col-3"></div>
          </div>
        </mat-card-content>
      </mat-card>
      <!-- Add Damage or Document -->
      <mat-card class="damageCard">
        <mat-card-title *ngIf="damageInEdit.InEdit" class="row unselectable subTitle subhead damageCaseCardTitle">Erstellen/Bearbeiten</mat-card-title>
        <mat-card-content>
          <!-- Buttons -->
          <div class="row" *ngIf="!damageInEdit.InEdit && !documentInEdit.InEdit">
            <div class="col-12 buttonContainer">
              <button type="button" class="whiteText" mat-button (click)="createNewDamage()"><i class="bi bi-plus-circle"></i> Schaden hinzufügen</button>
              <button type="button" class="whiteText" mat-button (click)="createNewDocument()"><i class="bi bi-plus-circle"></i> Dokument hinzufügen</button>
            </div>
          </div>
          <!-- Add Damage -->
          <div class="row damageRow" *ngIf="damageInEdit.InEdit">
            <div class="col-3">
              <mat-form-field class="w-100">
                <input type="text" placeholder="Bauteil" matInput [formControl]="damageAreaControl" [matAutocomplete]="autoDamageArea">
                <mat-autocomplete #autoDamageArea="matAutocomplete" [displayWith]="displayWithText('damageArea')">
                  <mat-option *ngFor="let item of filteredDamageAreas | async" [value]="item">{{item.Code}} - {{item.DescriptionDE}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field class="w-100">
                <input type="text" placeholder="Schadenart" matInput [formControl]="damageTypeControl" [matAutocomplete]="autoDamageType">
                <mat-autocomplete #autoDamageType="matAutocomplete" [displayWith]="displayWithText('damageType')">
                  <mat-option *ngFor="let item of filteredDamageTypes | async" [value]="item">{{item.Code}} - {{item.DescriptionDE}}</mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
            <div class="col-3 imageContainer">
              <div class="imageWrapper" *ngFor="let img of damageInEdit.Images; let i = index">
                <img [src]="img.Base64" (click)="onPreviewClick(img.Base64,img.FileName)">
                <i class="bi bi-trash deleteIcon" (click)="removeImage(i); $event.stopPropagation()"></i>
              </div>
            </div>
            <div class="col-3 damageButtonContainer">
              <button type="button" class="whiteText" mat-button (click)="removeDamage()" *ngIf="isExistingDamage()"><i class="bi bi-trash"></i> Löschen</button>
              <button type="button" class="whiteText" mat-button (click)="saveDamage()"><i class="bi bi-floppy"></i> Übernehmen</button>
              <button type="button" class="whiteText" mat-button (click)="cancelDamage()"><i class="bi bi-x-square"></i> Abbrechen</button>
              <div class="damageButtonContainer">
                <label for="hiddenButton"><i class="bi bi-file-image"></i> Bilder auswählen</label>
                <input id="hiddenButton" type="file" class="hiddenButton" hidden multiple="true" accept="image/*" (change)="onDamageFilesSelected($event)">
              </div>
            </div>
          </div>
          <!-- Add Document -->
          <div class="row damageRow" *ngIf="documentInEdit.InEdit">
            <div class="col-3">
              <mat-form-field class="w-100">
                <mat-select placeholder="Dokument-Typ" [(ngModel)]="documentInEdit.DocumentType" [ngModelOptions]="{ standalone: true }">
                  <mat-option *ngFor="let documentType of documentTypes" [value]="documentType.value">{{ documentType.label }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field class="formField">
                <mat-label>Dateiname</mat-label>
                <input matInput name="filename" [(ngModel)]="documentInEdit.FileName" readonly>
              </mat-form-field>
            </div>
            <div class="col-2 imageContainer">
              <div *ngIf="documentInEdit.Base64 != null">
                <img [src]="'./../../../../assets/images/file.svg'" (click)="onPreviewClick(documentInEdit.Base64, documentInEdit.FileName)">
              </div>
            </div>
            <div class="col-4 damageButtonContainer">
              <button type="button" class="whiteText" mat-button (click)="saveDocument()"><i class="bi bi-floppy"></i> Übernehmen</button>
              <button type="button" class="whiteText" mat-button (click)="cancelDocument()"><i class="bi bi-x-square"></i> Abbrechen</button>
              <button type="button" class="whiteText" mat-button (click)="removeDocument()" *ngIf="isExistingDocument()"><i class="bi bi-trash"></i> Löschen</button>
              <div class="damageButtonContainer">
                <label for="hiddenButton"><i class="bi bi-file-image"></i> Datei Auswählen</label>
                <input id="hiddenButton" type="file" class="hiddenButton" hidden multiple="false" (change)="onDocumentFileSelected($event)">
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <!-- Damages -->
      <mat-card class="damageCard" *ngIf="damageCase.Damages.length > 0">
        <mat-card-title class="row unselectable subTitle subhead damageCaseCardTitle">Schäden</mat-card-title>
        <mat-card-content>
          <div class="row damageRow" *ngFor="let damage of damageCase.Damages">
            <div class="col-3">
              <mat-form-field class="w-100">
                <mat-label>Bauteil</mat-label>
                <input matInput readonly [value]="getDamageAreaDescription(damage.AreaId)">
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field class="w-100">
                <mat-label>Schadenart</mat-label>
                <input matInput readonly [value]="getDamageTypeDescription(damage.TypeId)">
              </mat-form-field>
            </div>
            <div class="col-4 imageContainer">
              <div class="imageWrapper" *ngFor="let img of damage.Images; let i = index">
                <img [src]="img.Base64" (click)="onPreviewClick(img.Base64,img.FileName)">
              </div>
            </div>
            <div class="col-2 damageButtonContainer" *ngIf="!damageInEdit.InEdit && !documentInEdit.InEdit">
              <button type="button" class="whiteText" mat-button (click)="editDamage(damage)"><i class="bi bi-pencil"></i></button>
              <button type="button" class="whiteText" mat-button (click)="requestAdditionalFotosPopup(damage)" [disabled]="damage.AdditionalFotosRequested">Weitere Fotos anfordern</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <!-- Documents -->
      <mat-card class="damageCard" *ngIf="damageCase.DamageDocuments.length > 0">
        <mat-card-title class="row unselectable subTitle subhead damageCaseCardTitle">Dokumente</mat-card-title>
        <mat-card-content>
          <div class="row damageRow" *ngFor="let document of damageCase.DamageDocuments">
            <div class="col-3">
              <mat-form-field class="w-100">
                <mat-label>Dokument-Typ</mat-label>
                <input matInput readonly [value]="documentTypes[document.DocumentType].label">
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field class="w-100">
                <mat-label>Dateiname</mat-label>
                <input matInput readonly [value]="document.FileName">
              </mat-form-field>
            </div>
            <div class="col-5 imageContainer">
              <div>
                <img [src]="'./../../../../assets/images/file.svg'" (click)="onPreviewClick(document.Base64, document.FileName)">
              </div>
            </div>
            <div class="col-1 damageButtonContainer" *ngIf="!damageInEdit.InEdit && !documentInEdit.InEdit">
              <button type="button" class="whiteText" mat-button (click)="editDocument(document)"><i class="bi bi-pencil"></i></button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <!-- Comments -->
      <mat-card class="damageCard">
        <mat-card-title class="row unselectable subTitle subhead damageCaseCardTitle">Kommentare</mat-card-title>
        <mat-card-content>
          <div class="row comments">
            <mat-form-field class="col-12 formField">
              <textarea matInput name="comment" placeholder="Interner Kommentar" [(ngModel)]="damageCase.Comment" rows="4"></textarea>
            </mat-form-field>
            <mat-form-field class="col-12 formField">
              <textarea matInput name="insuranceComment" placeholder="Versicherungskommentar" [(ngModel)]="damageCase.InsuranceComment" rows="4"></textarea>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
      <!-- Feed -->
      <mat-card class="damageCard" *ngIf="damageCase.Feeds.length > 0">
        <mat-card-title class="row unselectable subTitle subhead damageCaseCardTitle">Aktivität</mat-card-title>
        <mat-card-content>
          <div class="feedInputContainer d-flex flex-row w-100">
            <div class="feedCircleContainer">
              <div class="feedCircle feedCircleInternal">{{userName|initials}}</div>
            </div>
            <div class="d-flex flex-column w-100 h-100">
              <div class="w-100"><strong>{{userName}}</strong></div>
              <quill-editor
                [(ngModel)]="feedHtmlString"
                [ngModelOptions]="{standalone: true}"
                theme="snow"
                placeholder="Schreib etwas...">
              </quill-editor>
              <div class="feedButtonContainer">
                <button type="button" class="whiteText" mat-button (click)="saveFeed()">Speichern</button>
              </div>
            </div>
          </div>
          <div class="feedHistoryContainer d-flex flex-row w-100" *ngFor="let feed of damageCase.Feeds">
            <div class="feedCircleContainer">
              <div class="feedCircle" [ngClass]="feed.SenderName === 'System' ? 'feedCircleSystem' : feed.ExternalSender ? 'feedCirtleExternal' : 'feedCircleInternal'">{{ feed.SenderName | initials }}</div>
            </div>
            <div class="d-flex flex-column w-100 h-100 ql-snow">
              <div class="feedHeader d-flex flex-column w-100">
                <div class="w-100"><strong>{{feed.SenderName}}</strong></div>
                <div><i style="color: gray;">{{feed.TimeStamp | date:'dd.MM.yyyy HH:mm:ss':'de' }}</i></div>
              </div>
              <div class="feedContent w-100 ql-editor" [innerHTML]="feed.ContentHtml|safeHtml"></div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-12 buttonContainer">
      <button type="button" class="whiteText" mat-button (click)="initData()"><i class="bi bi-arrow-counterclockwise"></i> Zurücksetzen</button>
      <button *ngIf="damageCase.Id !== 0" type="button" class="whiteText" mat-button (click)="deleteDamageCasePopup()"><i class="bi bi-trash"></i> Löschen</button>
      <button type="button" class="whiteText" mat-button (click)="saveDamageCase()"><i class="bi bi-floppy"></i> Speichern</button>
    </div>
  </form>
</div>
<app-footer></app-footer>